import React from 'react';
import { Mui } from '@osu/react-ui';
import { getScenarioLabel } from '../../../services/mock/applicationData';

/**
 * Scenario selector component for development testing
 * Allows switching between different test scenarios
 */
function ScenarioSelector({ 
  currentScenario, 
  availableScenarios = [], 
  onScenarioChange 
}) {
  return (
    <Mui.FormControl size="small" sx={{ minWidth: 200 }}>
      <Mui.InputLabel>Test Scenario</Mui.InputLabel>
      <Mui.Select
        value={currentScenario || ''}
        label="Test Scenario"
        onChange={(e) => onScenarioChange(e.target.value)}
      >
        {availableScenarios.map((scenario) => (
          <Mui.MenuItem key={scenario} value={scenario}>
            {getScenarioLabel(scenario)}
          </Mui.MenuItem>
        ))}
      </Mui.Select>
    </Mui.FormControl>
  );
}

export default ScenarioSelector;